import styled from 'styled-components';
import { Row } from 'antd';

export const StyledDemonstration = styled.div`
  &:hover {
    background: rgba(255, 255, 255, 0.89);
    box-shadow: 0px 2px 34px 0px rgba(39, 52, 125, 0.12);
  }

  & .identifying_content {
    background-color: #ebebeb;
    & .identifyingImgBox {
      padding: 10px;
      height: 144px;
      overflow: hidden;
    }
    & .identifyingImgBox.activeIndex {
      border: 2px solid #2372e0;
    }
  }
  & .identifying_content img {
    width: 100%;
    display: block;
    transform: translateY(-50%);
    margin-top: 72px;
  }
  & .identifying_result {
    height: 688px;
    overflow: auto;
    background-color: #fafafa;
  }
  & .identifying_result .ant-collapse,
  & .identifying_result .ant-collapse-content {
    background-color: #fafafa;
  }
  & .result_text span {
    margin-left: 20px;
  }
  & .ptr_result_text span {
    font-size: 14px;
    font: inherit;
    line-height: 14px;
    text-align: left;
    &.ocr-content-text {
      display: block;
      margin: 1em 0;
      line-height: 2em;
      color: rgba(4, 32, 68, 1);
    }
    &.katex-html {
      line-height: 2em;
    }
    &.mord {
      span {
        text-align: center;
      }
    }
  }
  & .origin_result_topic {
    text-algin: center;
    font-weight: 500;
  }
  & .correct_result {
    width: 100%;
  }
  & .correct_result .correct_result_item {
    width: 100%;
    margin-bottom: 20px;
  }
  & .correct_result .correct_result_item .correct_result_title {
    width: 100%;
    font-weight: 500;
  }
  & .correct_result .correct_result_item .correct_result_text {
    box-sizing: border-box;
    width: 100%;
    padding-left: 10px;
  }
  & .correct_result_text_subitem {
    width: 100%;
    margin-bottom: 10px;
  }
  & .correct_result_text_title {
    width: 100%;
    font-weight: 500;
  }

  & .identifying_input {
    display: flex;
    justify-content: space-between;
  }
  & .identifying_select_wrap {
    background: #fff;
  }
  & .identifying_select {
    display: flex;
    justify-content: space-between;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }
  & select {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }
  & select::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
  }

  & .identifying_upload {
    position: absolute;
    bottom: 0;
    padding: 10px 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    color: #ccc;
    & small {
      font-size: 14px;
      position: relative;
      top: 8px;
    }
  }
  & .thum_group {
    position: absolute;
    top: 20px;
    height: 430px;
    overflow: auto;
    & canvas {
      background-color: #ccc;
    }
    & img {
      width: 100%;
      margin: 0;
    }
  }
  & .canvasBox {
    height: 524px;
    & .thum_pic {
      border: 1px solid #ccc;
      padding: 10px;
      box-sizing: border-box;
    }
  }
`;
export const StyledRenderObjectThumResultRow = styled(Row)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.8);
  padding: 10% 25%;
  & .ocrResultContent {
    & ul {
      padding: 0;
      list-style: none;
      color: #fff;
      line-height: 40px;
      & li {
        padding-left: 10px;
        margin: 10px 0 0 0;
        line-height: 25px;
        color: #fff;
      }
    }
  }
`;
export const StyledRenderRecognizeFaceRow = styled(Row)`
  width: 100%;
  height: 100%;
  position: absolute;
  box-sizing: border-box;
  padding: 3% 5%;
  & .recognizeFaceResult {
    display: grid;
    align-content: center;
    justify-content: center;
    height: 416px;
    & img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
  & .recognizeFaceCompare {
    height: 100%;
    & .recognizeFaceResultTitle {
      color: #fff;
      margin-bottom: 20px;
    }
    & ul {
      padding: 0;
      list-style: none;
      & li {
        margin: 6px;
        float: left;
        color: #fff;
        width: 45%;
        height: 196px;
        position: relative;
        &:last-child:after {
          clear: both;
        }
        & img {
          display: block;
          margin: 0;
          width: 100%;
          height: 100%;
          transform: translateY(0);
        }
        & p {
          position: absolute;
          width: 100%;
          padding: 0 5px;
          display: block;
          box-sizing: border-box;
          line-height: 40px;
          text-align: center;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          color: #fff;
        }
      }
    }
  }
`;

export const StyledTrigonSpan = styled('span')`
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  display: block;
  border-color: transparent red;
  border-width: 0 0 50px 50px;
  border-style: solid;
  &:after {
    content: '${(props) => props.content}';
    position: absolute;
    left: -38px;
    top: 8px;
  }
`;

export const StyledCenterItem = styled(Row)`
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: space-around;
`;
